import React, { useEffect } from "react";
import type { ModalViewType } from "../../../../../../../../common-deprecated/types/CommonTypes";
import type { FinanceCalculatorModalType } from "../../../../../utils/modalConstants";
import Modal from "../../../../../../shared-components/css-modules/toyota/organisms/Modal";
import useAphFinanceCalculatorButton from "../../../../../hooks/useAphFinanceCalculatorButton";
import CalculatorError from "./CalculatorError";
import { useCarConfigLabel } from "../../../../../utils/labelUtils";

const FinanceCalculatorModal = (props: ModalViewType<FinanceCalculatorModalType>): JSX.Element => {
    const { show, modalSettings } = props;
    const { injectionError } = modalSettings;

    const { showCalculator, isT1InjectionReady, onClose, containerId } = useAphFinanceCalculatorButton(
        modalSettings.origin,
    );

    const label = useCarConfigLabel("carConfigBackToCashPurchase");

    useEffect(() => {
        if (isT1InjectionReady) showCalculator();

        // UseEffect only needs to rerun when the isT1InjectionReady changes
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isT1InjectionReady]);

    return (
        <Modal
            open={show}
            onRequestClose={onClose}
            headerAction={{
                onClick: () => onClose("cash"),
                label,
                icon: "arrow-left",
            }}
            variant="bottom"
        >
            {injectionError ? (
                <CalculatorError />
            ) : (
                <div className="tor-modal-content or-modal-content modal-body">
                    <div className="tor-modal-body">
                        <div id={containerId} />
                    </div>
                </div>
            )}
        </Modal>
    );
};

export default FinanceCalculatorModal;
